import { SerializableObject } from './serializable-object';


export abstract class DuplicatableObject extends SerializableObject {
  /**
   * A list of properties to be removed from duplicated instances.
   */
  protected getDuplicateCleanupProperties(): string[] {
    return [
      'id',
      'recordId',
    ];
  }

  /**
   * Duplicate the current DO.
   */
  public duplicate() {
    const data: any = this.prepareDuplicateObjectData();
    const objPrototype = Object.getPrototypeOf(this);
    return new objPrototype.constructor(data);
  }

  /**
   * Build and prepare a bag of data from the source object.
   */
  protected prepareDuplicateObjectData(): any {
    const newObjectData: any = {};

    const primitiveProperties: string[] = Object.keys(this);
    primitiveProperties.forEach((property: string): void => {
      if (this.getDuplicateCleanupProperties().indexOf(property) !== -1) {
        return;
      }
      newObjectData[property] = this.duplicatePropertyValue(property, (this as any)[property]);
    });

    return newObjectData;
  }

  /**
   * Clone and process individual properties for the source object.
   *
   * @param _property The name of the property to clone.
   * @param propertyValue The value of the property to clone.
   */
  protected duplicatePropertyValue(_property: string, propertyValue: any): any {
    if (Array.isArray(propertyValue)) {
      const newPropertyValue: any[] = [];
      propertyValue.forEach((arrayValue: any, index: number): void => {
        newPropertyValue[index] = (arrayValue instanceof DuplicatableObject) ? arrayValue.duplicate() : arrayValue;
      });
      return newPropertyValue;
    }

    return (propertyValue instanceof DuplicatableObject) ? propertyValue.duplicate() : propertyValue;
  }
}
